var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-dialogContainer"},[_c('BaseBusiness',{ref:_vm.item.name,attrs:{"formParam":_vm.item,"opCode":_vm.opCode,"defaultData":_vm.msg}}),_c('div',{staticClass:"h-clear-rowMg"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }